module.exports = __webpack_public_path__ + "static/media/1004998.610c460b.png";